import { render, staticRenderFns } from "./GatewayRules.vue?vue&type=template&id=32b0d7d9"
import script from "./GatewayRules.vue?vue&type=script&lang=js"
export * from "./GatewayRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports